import clsx from 'clsx';
import styles from './OptionBox.module.scss';
import SoundSvg from '~/assets/icons/sound.svg';
function OptionBox({ children, className, box, multi, questionType, handlePlay, ...rest }) {
    const handleOnClickPlayAudio = (e, text) => {
        // e.stopPropagation();
        if(handlePlay)
            handlePlay(text);
    };
    return (
        <div
            {...rest}
            className={clsx(
                styles.box,
                box.status === 'disable' && styles.disable,
                box.status === 'choosen' && styles.choosen,
                box.status === 'error' && styles.error,
                box.status === 'right' && styles.right,
                box.animationRight && styles.right,
                className,
            )}
        >
            <div className={clsx(styles.text)}>
                {questionType === 'multiple-choices-listening' ? (
                    <img src={SoundSvg} alt="Sound" onClick={(e) => handleOnClickPlayAudio(e, box.text)}/>
                    ) : (
                    box.text
                )}
            </div>
            <div
                className={clsx(
                    styles.icon,
                    box.status === 'choosen' && styles.choosen,
                    box.status === 'error' && styles.error,
                    box.status === 'right' && styles.right,
                )}
            >
                {box.status === 'choosen' || box.choosen ? (
                    multi ? (
                        <i className="fa-regular fa-square-check"></i>
                    ) : (
                        <i className="fa-regular fa-circle-dot"></i>
                    )
                ) : multi ? (
                    <i className="fa-regular fa-square"></i>
                ) : (
                    <i className="fa-regular fa-circle"></i>
                )}
            </div>
        </div>
    );
}
export default OptionBox;
